module.exports = __webpack_public_path__ + "static/Avion-5fcb8ed6ab3060f87e2f5078f31dd2e7.jpg";